import { createDateTimeColumn } from '@app/components/date/create-date-time-column';
import { createCustomIdColumn } from '@app/modules/audit/components/create-custom-id-column';
import { MrtTable } from '@mi-front/ui';
import { useIntl } from 'react-intl';
import { BcrEntry } from '../../../station-reports.types';

export function UnverifiedBcrEntriesTable({ data }: { data: BcrEntry[] }) {
  const { $t } = useIntl();

  return (
    <MrtTable
      data={data}
      columns={[
        createDateTimeColumn<BcrEntry>($t, {
          accessor: (row) => row.datetime,
          enableColumnFilter: false,
          filterVariant: 'time-range',
          size: 150,
        }),
        createCustomIdColumn<BcrEntry>($t, {
          accessor: (row) => row.customId,
          enableColumnFilter: true,
          filterFn: 'contains',
        }),
        {
          id: 'name',
          header: $t({
            id: 'audit.reportsScreen.bcrMatches.unverifiedBcrEntries.name',
            defaultMessage: 'Nombre',
          }),
          accessorKey: 'name',
          enableSorting: true,
          enableColumnFilter: true,
          filterFn: 'contains',
        },
      ]}
    />
  );
}
